import { enums, createInstance } from '@optimizely/optimizely-sdk';
import axios from 'axios';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function getVisit() {
  var _window, _window$tracking;

  // @ts-ignore
  var visit = (_window = window) == null ? void 0 : (_window$tracking = _window.tracking) == null ? void 0 : _window$tracking.visit();

  if (visit) {
    return visit;
  }

  var cookie = document.cookie.split(';').find(c => c.trim().startsWith('visit'));

  if (cookie) {
    visit = cookie.split('=')[1].trim();
  }

  return visit;
}

function initLogging(url, version) {
  var sendRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (payload) {
      return yield axios.post(url, payload, {
        headers: {
          'Content-Type': 'text/plain'
        }
      });
    });

    return function sendRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var log = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (level, message, contextData) {
      try {
        var _window2, _window3;

        var dataToSend = JSON.stringify({
          message,
          contextData,
          logLevel: level,
          url: (_window2 = window) == null ? void 0 : _window2.location.href,
          userAgent: (_window3 = window) == null ? void 0 : _window3.navigator.userAgent,
          visit: getVisit(),
          version
        });
        yield sendRequest(dataToSend);
      } catch (e) {
        console.error("There was an error logging another error: " + message, e);
      }
    });

    return function log(_x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    error: function () {
      var _error = _asyncToGenerator(function* (message, contextData) {
        yield log('ERROR', message, contextData);
      });

      function error(_x5, _x6) {
        return _error.apply(this, arguments);
      }

      return error;
    }(),
    warn: function () {
      var _warn = _asyncToGenerator(function* (message, contextData) {
        yield log('WARN', message, contextData);
      });

      function warn(_x7, _x8) {
        return _warn.apply(this, arguments);
      }

      return warn;
    }(),
    info: function () {
      var _info = _asyncToGenerator(function* (message, contextData) {
        yield log('INFO', message, contextData);
      });

      function info(_x9, _x10) {
        return _info.apply(this, arguments);
      }

      return info;
    }()
  };
}

class Logger {
  constructor(version, libraryName, appName) {
    if (!version || !libraryName || !appName) {
      throw new Error("Parameters version, libraryName and appName are required, given: " + version + "/" + libraryName + "/" + appName);
    }

    this.libraryName = libraryName;
    this.sumoLogger = initLogging('https://endpoint1.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV1xIgc-SeJ99Es8Q-JdwHIjyPRHWa-sgqe4MtDs3MwJ_t3atmErfcFKguBc50QH7W8jcJy-AJrDSEo0LmYATdc4e1S0sPWf6y5E1TuRi028Dw==', version);
    this.appName = appName;
  }

  static getLogger(version, libraryName, appName) {
    return new Logger(version, libraryName, appName);
  }

  error(message, error) {
    var contextData = error ? {
      error: JSON.stringify(error, Object.getOwnPropertyNames(error))
    } : {};
    this.localLog(message, contextData);
    this.sumoLogger.error(message, this.prepareContextData(contextData));
  }

  info(message) {
    this.localLog(message);
    this.sumoLogger.info(message, this.prepareContextData());
  }

  warn(message) {
    this.localLog(message);
    this.sumoLogger.warn(message, this.prepareContextData());
  }

  localLog(message, contextData) {
    if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
      console.log(message, contextData);
    }
  }

  prepareContextData(contextData) {
    return _extends({}, contextData, {
      libraryName: this.libraryName,
      appName: this.appName
    });
  }

}

var filterMessage = message => 'DatafileManager: Error fetching datafile: Request error' === message;

var createCustomLogger = logger => {
  return (level, message) => {
    if (filterMessage(message)) {
      return;
    }

    var LOG_LEVEL = enums.LOG_LEVEL;

    switch (level) {
      case LOG_LEVEL.INFO:
        logger.info(message);
        break;

      case LOG_LEVEL.DEBUG:
        logger.info(message);
        break;

      case LOG_LEVEL.WARNING:
        logger.warn(message);
        break;

      case LOG_LEVEL.ERROR:
        logger.error(message);
        break;
    }
  };
};

var optimizelyClientCache = {};
var logWarnings = {};
var DEFAULT_FEATURE_SDK_KEY = '9FP7UbgVrDnMwRHbjK2A3';
var DATAFILE_REFRESH_INTERVAL = 120000; //2 minutes

var MISSING_USER_ID = 'USER_ID_IS_MISSING';

var getsdkKeyOrDefault = sdkKey => sdkKey || DEFAULT_FEATURE_SDK_KEY;

var checkClientReady = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator(function* (optimizelyClient) {
    var result = yield optimizelyClient.onReady({
      timeout: 1000
    });

    if (!result.success) {
      throw new Error('Initialization error: ' + result.reason);
    }
  });

  return function checkClientReady(_x) {
    return _ref.apply(this, arguments);
  };
}();

var initialize = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator(function* (logger, sdkKey, dataFile) {
    try {
      if (optimizelyClientCache[sdkKey]) {
        yield checkClientReady(optimizelyClientCache[sdkKey]);
        return {
          optimizelyClient: optimizelyClientCache[sdkKey],
          error: null
        };
      }

      optimizelyClientCache[sdkKey] = createInstance({
        sdkKey: sdkKey,
        datafile: dataFile,
        datafileOptions: {
          autoUpdate: true,
          urlTemplate: 'https://config.exp.vpsvc.com/datafiles/%s.json',
          updateInterval: DATAFILE_REFRESH_INTERVAL
        },
        eventBatchSize: 10,
        eventFlushInterval: 3000,
        logger: {
          log: createCustomLogger(logger)
        },
        logLevel: 'error'
      });
      yield checkClientReady(optimizelyClientCache[sdkKey]);
      return {
        optimizelyClient: optimizelyClientCache[sdkKey],
        error: null
      };
    } catch (e) {
      return {
        optimizelyClient: optimizelyClientCache[sdkKey],
        error: e
      };
    }
  });

  return function initialize(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

class FeaturesClientCore {
  constructor(_ref3, logger, sdkKey) {
    var {
      optimizelyClient,
      error
    } = _ref3;
    this.logger = logger;
    this.error = error;
    this.optimizelyClient = optimizelyClient;
    this.sdkKey = sdkKey;
  }

  static getFeaturesClient(logger, sdkKey, dataFile) {
    return _asyncToGenerator(function* () {
      sdkKey = getsdkKeyOrDefault(sdkKey);
      var initializationResult = yield initialize(logger, sdkKey, dataFile);
      return new FeaturesClientCore(initializationResult, logger, sdkKey);
    })();
  }

  isFeatureEnabled(featureName, context) {
    if (!this.isInitialized()) {
      this.logInitializationWarning("Inconsistent state after initialization: isFeatureEnabled: [" + featureName + "]");
      return false;
    }

    var workingContext = this.getContextOrDefault(context);
    var result = this.optimizelyClient.isFeatureEnabled(featureName, workingContext.userId, workingContext.attributes);

    if (workingContext.overrides && workingContext.overrides[this.sdkKey] && featureName in workingContext.overrides[this.sdkKey]) {
      result = workingContext.overrides[this.sdkKey][featureName];
    }

    return !!result;
  }

  getEnabledFeatures(context) {
    if (!this.isInitialized()) {
      this.logInitializationWarning('Inconsistent state after initialization: getAllEnabledFeatures');
      return [];
    }

    var workingContext = this.getContextOrDefault(context);
    var baseFeatures = this.optimizelyClient.getEnabledFeatures(workingContext.userId, workingContext.attributes);

    if (workingContext.overrides && workingContext.overrides[this.sdkKey]) {
      for (var [feature, value] of Object.entries(workingContext.overrides[this.sdkKey])) {
        var index = baseFeatures.indexOf(feature);

        if (!value && index >= 0) {
          //Override set to false, remove if found
          baseFeatures.splice(index, 1);
        } else if (value && index < 0) {
          //override is true, add if not already in the list
          baseFeatures.push(feature);
        }
      }
    }

    return baseFeatures;
  }

  isInitialized() {
    return !!this.optimizelyClient && this.optimizelyClient.isValidInstance();
  }

  getContextOrDefault(context) {
    if (!context || !context.userId) {
      this.logger.error('Decision method called without proper context');
      return _extends({}, context, {
        userId: MISSING_USER_ID
      });
    }

    return context;
  }

  logInitializationWarning(message) {
    if (!logWarnings[message]) {
      this.logger.error(message, this.error);
      logWarnings[message] = 1;
    }
  }

}

export { FeaturesClientCore, Logger, getsdkKeyOrDefault };
//# sourceMappingURL=ft-reader-core.esm.js.map
